<template>
  <vx-card no-shadow>
    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-input v-if="module" label="" placeholder="Title..." :content.sync="module.title" class="w-full" />
      </div>
    </div>

    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-textarea v-if="module" placeholder="Description..." :content.sync="module.description" class="w-full" />
      </div>
    </div>

    <h5 class="mb-3">Participation rules</h5>
    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Define the minimum score for the participant to pass the module</span>
      </div>
      <div class="vx-col">
        <vs-input v-if="module" v-validate="'numeric'" name="requiredPerformanceScore" v-model="module.requiredPerformanceScore" />
        <div v-if="module" class="text-danger text-sm" v-show="errors.has('requiredPerformanceScore')">{{ errors.first('requiredPerformanceScore') }}</div>
      </div>
    </div>

    <h5 class="mb-3">Redo lessons</h5>
    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Should the participant be able to redo lessons in this module to attempt a new score? - This settings can afterwards be disabled for specific lessons</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="module" v-model="module.canRedoLessons"/>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <TypedSurveyImages v-if="module" 
      :item="module" 
      :assetUrl="'OnlineTraining/' + this.surveyId + '?moduleId=' + this.moduleId"
      style="width: 100%;" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save General Info</vs-button>
    </div>
  </vx-card>
</template>

<script>

const TypedSurveyImages = () => import("./../../components/TypedSurveyImages.vue");

export default {
  components: {
    TypedSurveyImages
  },
  props: {
    module: Object
  },
  data () {
    return {
      surveyId: '',
      moduleId: '',

      name: ''
    }
  },
  methods: {
    /*
    getModule: function () {
      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules/' + this.moduleId;
      console.log(url);
      
      this.$http.get(url)
          .then(resp => {
            console.log("Module: ", resp.data);
            this.module = resp.data;
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not get module: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },*/

    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      const payload = {
        title: this.module.title,
        description: this.module.description,
        requiredPerformanceScore: parseInt(this.module.requiredPerformanceScore),
        canRedoLessons: this.module.canRedoLessons
      }

      console.log(payload)

      this.$http.put(process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules/' + this.moduleId + '/info/general', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Module saved'
            });
          })
          .catch(err => {
            console.log(err);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save module: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;

    //this.getModule();
  }
}
</script>
